<marv-sub-item>
    <div class="content_sub_item">
        <div class="content_agent">
            <ion-icon name="person-outline"></ion-icon>{{this.permanentAgent.name}}    
        </div>
        <div class="content_sub_item_right">
            @if(this.permanentAgent.planningRate7Days && this.permanentAgent.planningRate15Days){
                <div class="agent_planning_rate">
                    <ion-label>{{'PLANNING_RATE' | translate}}</ion-label>

                    @if(this.rateSelected === '7D'){
                        <marv-progress-bar [value]="this.permanentAgent.planningRate7Days" [showMax]="false" size="small" [color]="this.getColorPlanningRateDays(this.permanentAgent.planningRate7Days)"/>
                    }
                    @else if(this.rateSelected === '15D'){
                        <marv-progress-bar [value]="this.permanentAgent.planningRate15Days" [showMax]="false" size="small" [color]="this.getColorPlanningRateDays(this.permanentAgent.planningRate15Days)"/>
                    }

                    <div class="buttons_select_rate">
                        <div class="button_select_rate" [class.selected]="this.rateSelected === '7D'" (click)="this.selectRate('7D')">{{'7_DAYS' | translate}}</div>
                        <div class="button_select_rate" [class.selected]="this.rateSelected === '15D'" (click)="this.selectRate('15D')">{{'15_DAYS' | translate}}</div>
                    </div>
                </div>
            }
            <marv-button icon="calendar-outline" [rounded]="true" [withMargin]="false" (click)="this.seePlanning()" />  
        </div>
    </div>
</marv-sub-item>